import { useReveal } from '../hooks/useReveal.js';
import { DeviceFrame } from '../components/DeviceFrame.js';
import { PhoneShot } from '../components/PhoneShot.js';

export function BothWorlds() {
  const headerRef = useReveal<HTMLDivElement>(0.3);
  const compositeRef = useReveal<HTMLDivElement>(0.2);

  return (
    <section
      id="everywhere"
      className="relative w-full overflow-hidden"
      style={{ padding: '76px 20px' }}
    >
      <div className="mx-auto max-w-container">
        <div ref={headerRef} className="ow-reveal text-center max-w-[760px] mx-auto">
          <p
            className="font-display uppercase text-gold"
            style={{ fontSize: 11, letterSpacing: '0.32em' }}
          >
            § V - Everywhere
          </p>
          <h2
            className="font-display text-primary mt-5"
            style={{
              fontSize: 'clamp(32px, 5vw, 56px)',
              fontWeight: 500,
              letterSpacing: '0.02em',
            }}
          >
            Built for both worlds.
          </h2>
          <p className="scripture text-secondary mt-4" style={{ fontSize: 22, lineHeight: 1.5 }}>
            The full Orthodox life on the desktop. The same life in your pocket. Same data, same
            calendar, same rhythm.
          </p>
        </div>

        <div
          ref={compositeRef}
          className="ow-reveal ow-composite group relative mt-16 mx-auto hidden md:block"
          style={{ maxWidth: 1080 }}
        >
          <div className="ow-composite-desktop ow-float-a">
            <DeviceFrame variant="desktop">
              <DesktopMock />
            </DeviceFrame>
          </div>

          <div
            className="ow-composite-phone ow-float-b absolute hidden md:block"
            style={{ right: '-2%', bottom: '-12%', width: 240 }}
          >
            <DeviceFrame variant="phone">
              <PhoneShot src="/mobile-screens/today.jpg" alt="Orthodox Way mobile app, Today" />
            </DeviceFrame>
          </div>

          {/* Floating CTA on hover */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition pointer-events-none">
            <span className="ow-cta-primary pointer-events-auto">Try the demo</span>
          </div>
        </div>

        {/* Mobile fallback phone, stacked */}
        <div className="md:hidden mt-8 flex justify-center">
          <DeviceFrame variant="phone">
            <PhoneShot src="/mobile-screens/today.jpg" alt="Orthodox Way mobile app, Today" />
          </DeviceFrame>
        </div>
      </div>
    </section>
  );
}

function DesktopMock() {
  return (
    <div className="h-full grid grid-cols-[180px_1fr] bg-bg">
      <aside className="border-r border-border p-4 bg-bg-subtle">
        <p
          className="font-display uppercase text-gold"
          style={{ fontSize: 9, letterSpacing: '0.3em' }}
        >
          Orthodox Way
        </p>
        <ul className="mt-4 space-y-2 text-secondary" style={{ fontSize: 11 }}>
          {[
            'Today',
            'Prayers',
            'Fasting',
            'Readings',
            'Services',
            'Calendar',
            'Saints',
            'Learn',
          ].map((l, i) => (
            <li key={l} className={i === 0 ? 'text-gold' : ''} style={{ letterSpacing: '0.04em' }}>
              {l}
            </li>
          ))}
        </ul>
      </aside>
      <main className="p-6">
        <p
          className="font-display uppercase text-gold"
          style={{ fontSize: 9, letterSpacing: '0.3em' }}
        >
          Tuesday · Tone 4
        </p>
        <h4 className="font-display text-primary mt-2" style={{ fontSize: 22 }}>
          Today
        </h4>
        <div className="grid grid-cols-3 gap-3 mt-4">
          {['Morning Prayers', 'Day’s Saint', 'Fasting'].map((t) => (
            <div key={t} className="border border-border rounded-sm p-3" style={{ minHeight: 80 }}>
              <p
                className="font-display uppercase text-muted"
                style={{ fontSize: 8, letterSpacing: '0.3em' }}
              >
                Card
              </p>
              <p className="font-display text-primary mt-1.5" style={{ fontSize: 12 }}>
                {t}
              </p>
            </div>
          ))}
        </div>
        <div className="mt-4 border-t border-border pt-3">
          <p
            className="font-display uppercase text-gold"
            style={{ fontSize: 8, letterSpacing: '0.3em' }}
          >
            Readings
          </p>
          <p className="text-secondary mt-1" style={{ fontSize: 10 }}>
            Hebrews 7:7–17 · Mark 9:33–41
          </p>
        </div>
      </main>
    </div>
  );
}
